import { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { fetchPageBySlug } from "../api/axios";

import Faq from "../components/common/Faq";
import FormSection from "../components/sections/FormSection";
import DynamicBreadcrumb from "../components/common/DynamicBreadcrumb";
import ImageWithText from "../components/sections/ImageWithText";
import AboutUs from "../components/sections/AboutUs";
import Seo from "../components/_App/seo";
import WeServe from "../components/sections/WeServe";
import StrategyRenderer from "../components/common/StrategyRenderer";
import NotFoundPage from "./NotFound";
import Preloader from "../components/_App/Preloader";

const IndustryDetails = () => {
  const { slug } = useParams();
  const location = useLocation();
  const [pageData, setPageData] = useState(undefined);

  const componentMap = {
    "sections.top-form-with-text": FormSection,
    "sections.about-area-section": AboutUs,
    "sections.image-with-text": ImageWithText,
    "sections.industries-section": WeServe,
    "sections.services-card": StrategyRenderer,
    "sections.faq": Faq,
  };
  useEffect(() => {
  if (slug) {
    fetchPageBySlug(slug).then((data) => {
      setPageData(data ?? null);
    });
  }
}, [slug]);
if (pageData === undefined) return <Preloader />;
if (pageData === null) {
  return <NotFoundPage />;
}
  return (
    <>
      {pageData && (
        <Seo
          seo={pageData?.seo}
          slug={location.pathname.substring(1)} 
        />
      )}

      <DynamicBreadcrumb title={pageData?.Title} />

      {pageData?.sections?.map((section) => {
        const SectionComponent = componentMap[section.__component];

        return SectionComponent ? (
          <SectionComponent key={section.id} data={section} />
        ) : null;
      })}
    </>
  );
};

export default IndustryDetails;